<section class="d-flex align-items-stretch justify-content-center old-style">
  <div class="col-xs-12 col-sm-8 col-md-6 offset-sm-2 offset-md-0 d-flex">
    <div class="col-md-11 offset-md-1 col-lg-9 offset-lg-3 col-xl-8 offset-xl-4 d-flex align-items-center">
      <div class="mx-auto pb-5 mb-5">
        <a href="https://{{appVariables.WHITELABEL_LINK}}" class="pb-5">
          <img class="d-block logo" src="assets/img/{{appVariables.WHITELABEL_LOGO}}" alt="{{appVariables.WHITELABEL_BRAND}}"/>
        </a>

        <div class="pt-5">
          <form [formGroup]="form" class="p-3 m-0" id="loginForm" name="loginForm" (ngSubmit)="submitting=true; login()">
            <h2 class="mb-3 into pt-1">Log in to your account</h2>
            <div class="form-group">
              <label for="username" class="control-label">Username</label>
              <input
                id="username"
                type="text"
                formControlName="username"
                autocomplete="username"
                class="form-control"
                [ngClass]="{'is-invalid': usernameControl.touched && usernameControl.invalid}"
              />
              <control-messages [control]="usernameControl"></control-messages>
            </div>
            <div class="form-group">
              <label for="password" class="control-label">Password</label>
              <input
                id="password"
                type="password"
                formControlName="password"
                autocomplete="password"
                class="form-control"
                [ngClass]="{'is-invalid': passwordControl.touched && passwordControl.invalid}"
              />
              <control-messages [control]="passwordControl"></control-messages>
            </div>
            <button
              id="login-button"
              type="submit"
              class="btn btn-info btn-lg w-100 mb-2"
              [disabled]="form.invalid || submitting"
              angularticsCategory="auth"
              angulartics2On="click"
              angularticsAction="Log In"
            >Login</button>
            <div class="d-flex flex-nowrap justify-content-start">
              <a
                [routerLink]="[]"
                (click)="createAccount()"
                angularticsCategory="auth"
                angulartics2On="click"
                angularticsAction="Sign Up Toggle"
              >Create an account</a>
              <a
                [routerLink]="[]"
                (click)="toggle.emit(authStates.resetPassword)"
                class="ml-auto"
                angularticsCategory="auth"
                angulartics2On="click"
                angularticsAction="Reset Password Toggle"
              >Forgot password?</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="d-none d-md-flex col-md-6 bg-secondary bg-curved">
    <div *ngIf="announcement" class="col-md-11 offset-md-1 col-lg-9 col-xl-8 d-flex align-items-center">
      <div class="d-flex flex-column">
        <div class="d-flex flex-row align-items-center pb-1">
          <tr-icon [icon]="iconCodeToString[announcement.icon]" [size]="size.medium" class="mr-2" [white]="true"></tr-icon>
          <h2 class="text-white mb-0" [innerText]="announcement.title"></h2>
        </div>
        <p class="text-white" [innerHtml]="announcement.content"></p>
        <a [href]="announcement.readMoreUrl" target="_blank">Learn more</a>
        <div class="d-flex flex-column align-items-center">
          <img class="announcement-image" [src]="announcement.imageUrl" alt=""/>
        </div>
      </div>
    </div>
  </div>
</section>
